
// thirty party imports
import React from 'react'


// own components

import { SignUpComponent } from '../components/auth/signup'

export const SignUp = () => {

    return <SignUpComponent />
}